import './styles.css';
import './pages/dynamicApply.css';
import './pages/dynamicApplyRepeatable.css';
import './pages/dynamicApplyBorders.css';
import { renderDynamicApplyPage } from './pages/dynamicApplyGuard';
import { renderOfferPage } from './pages/offer';
import { renderHrPage } from './pages/hr';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Missing #app');

const path = window.location.pathname.replace(/\/+$/, '') || '/apply';

if (path === '/' || path === '/apply') {
  void renderDynamicApplyPage(root);
} else if (path === '/offer') {
  renderOfferPage(root);
} else if (path === '/hr' || path.startsWith('/hr/')) {
  renderHrPage(root);
} else {
  root.innerHTML = '<div class="shell"><div class="card"><h1>Page not found</h1></div></div>';
}
